import { Spacing12, Spacing28 } from 'autogen/design-tokens/tokens';
import type { ProductTabIconItemModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import WebsiteIcon from 'components/Icon/SupplierIcon';
import { removeListStyling } from 'modules/helpers/mixins';
import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';

const List = styled.ul`
    ${removeListStyling}

    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: ${Spacing12};
`;

const Item = styled.li`
    display: grid;
    grid-column-gap: ${Spacing28};
    grid-template-columns: 40px 1fr;
    align-items: center;
`;

const StyledWebsiteIcon = styled(WebsiteIcon)`
    max-width: 100%; // iOS fix
`;

const StyledBody = styled(Typography.Body)`
    word-break: break-all;
`;
interface IIconList extends HTMLAttributes<HTMLUListElement> {
    items: ProductTabIconItemModel[];
}

export default function IconList({ items, ...restProps }: IIconList): JSX.Element {
    return (
        <List {...restProps}>
            {items.map((item) => {
                const { icon, name, text } = item;
                return (
                    <Item key={name}>
                        <StyledWebsiteIcon icon={icon} />
                        <StyledBody as="span">{text}</StyledBody>
                    </Item>
                );
            })}
        </List>
    );
}
